import { render, staticRenderFns } from "./GBrandCard.vue?vue&type=template&id=6518aa80&"
import script from "./GBrandCard.vue?vue&type=script&lang=ts&"
export * from "./GBrandCard.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports